import React from 'react';
import { SettlementStatusResponse } from '@/entities/settlement/api/settlement.api';
import { Badge } from '@/shared/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { formatSettlementYearMonth } from '@/pages/settlements/settlementUtils';

interface SettlementStatusBannerProps {
  settlementYearMonth: string;
  status?: SettlementStatusResponse;
  isLoading?: boolean;
}

const StatusBadge = ({ done, doneLabel, pendingLabel }: {
  done: boolean;
  doneLabel: string;
  pendingLabel: string;
}) => (
  <Badge variant={done ? 'default' : 'destructive'}>
    {done ? doneLabel : pendingLabel}
  </Badge>
);

export const SettlementStatusBanner: React.FC<SettlementStatusBannerProps> = ({
  settlementYearMonth,
  status,
  isLoading,
}) => (
  <Card>
    <CardHeader className="pb-2">
      <CardTitle className="text-base">
        {formatSettlementYearMonth(settlementYearMonth)} 정산 상태
      </CardTitle>
    </CardHeader>
    <CardContent>
      {isLoading || !status ? (
        <p className="text-sm text-muted-foreground">상태를 불러오는 중…</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">자료 업로드</p>
            <StatusBadge
              done={status.isUploaded}
              doneLabel="업로드 완료"
              pendingLabel="업로드 미완료"
            />
          </div>
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">정산 정보 생성</p>
            <StatusBadge
              done={status.isGenerated}
              doneLabel="생성 완료"
              pendingLabel="생성 미완료"
            />
          </div>
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">제약사 정산 병합</p>
            <StatusBadge
              done={status.isPharmaMerged}
              doneLabel="병합 완료"
              pendingLabel="병합 미완료"
            />
          </div>
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">정산 데이터 게시</p>
            <StatusBadge
              done={status.isPublished}
              doneLabel="게시 완료"
              pendingLabel="게시 미완료"
            />
          </div>
        </div>
      )}
    </CardContent>
  </Card>
);
